// extracted by mini-css-extract-plugin
export default {"wrapper":"DropdownSelect_wrapper__z3sRN","errorMessage":"DropdownSelect_errorMessage__YKMb9"};